import React, { useState, useEffect } from 'react';
import { propsToJS } from '__utils/immutable-to-js';
import UserSelector from 'views/user/user.selector';
import { useDispatch, useSelector } from 'react-redux';
import { useDeepCompare } from 'hooks/use-deep-memo';
import { fetchUserProfileInfo } from 'views/user/user.actions';
import { isProUser } from '__utils/common-utils';
import { useMediaQuery } from 'react-responsive';
import { Row, Col } from 'antd';
import { maskNumbers } from '__utils/helpers';

interface WidthProps {
    vertical?: boolean;
}

const UserBankInfoSlab: React.FC<WidthProps> = ({ vertical }: WidthProps) => {
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { userProfileInfo } = propsToJS(useSelector(UserSelector));
    const [ bankDetails, setBankDetails ] = useState<any>();

    useEffect(() => {
        !userProfileInfo && dispatch(fetchUserProfileInfo());
    }, []);

    useEffect(() => {
        setBankDetails(userProfileInfo?.userBankDetails);
    }, [ useDeepCompare(userProfileInfo) ]);

    return <div>
        { bankDetails &&
            <div className={ isMobile ? 'mint-box' : '' }>
                <div className={ isProUser() ? "bankDetailBox mt15" : "bankDetailBox" } style={ { paddingLeft: isMobile ? '16px' : '0', paddingBottom: isMobile ? '' : '0' } }>
                    <h4>Bank Details</h4>
                    <Row gutter={ 32 }>
                        <Col xs={ 24 } md={ vertical ? 24 : 12 }>
                            <p>Account Number: <span>{ maskNumbers(bankDetails?.bankAccountNumber, 3) }</span></p>
                        </Col>
                        <Col xs={ 24 } md={ vertical ? 24 : 12 } style={ { paddingLeft: vertical ? '16px' : isMobile ? '16px' :'50px' } }>
                            <p>IFSC Code: <span>{ bankDetails?.ifscCode }</span> </p>

                        </Col>
                    </Row>

                </div>
            </div> }
    </div>;
}

export default UserBankInfoSlab;